// extracted by mini-css-extract-plugin
export default {"adminRole":"UserItem_adminRole__u-5k5","therapeuteRole":"UserItem_therapeuteRole__KNAwi","educateurRole":"UserItem_educateurRole__2mU1B"};